import Box from '@mui/material/Box'
import styled from '@mui/material/styles/styled'

export const Details = styled(Box, {
  name: 'Details',
  slot: 'Root',
  skipSx: true,
})`
  font-size: 14px;
`
